import { CacheProvider as EmotionCacheProvider } from '@emotion/react';

import { useCacheByDirection, useDirection } from './hooks';

import type { FC, PropsWithChildren as CacheProviderProps } from 'react';

export const CacheProvider: FC<CacheProviderProps> = ({ children }) => {
  const direction = useDirection();
  const cache = useCacheByDirection(direction);

  return <EmotionCacheProvider value={cache}>{children}</EmotionCacheProvider>;
};
